<template>
    <aside class="main-sidebar" id="sideNav">
        <section class="sidebar">
            <ul class="sidebar-menu">
                <router-link tag="li" :to="{ name: 'organization', query: {page: 1} }" exact>
                    <a class="nav-link">
                        <font-awesome-icon icon="building" style="width: 25px" /> <span>Organizations</span>
                    </a>
                </router-link>
                <router-link tag="li" :to="{ name: 'connection', query: {page: 1} }" exact>
                    <a class="nav-link"><font-awesome-icon icon="database" style="width: 25px" /> <span>Connections</span></a>
                </router-link>
                <router-link tag="li" :to="{ name: 'query', query: {page: 1} }" exact>
                    <a class="nav-link"><font-awesome-icon icon="terminal" style="width: 25px" /> <span>Queries</span></a>
                </router-link>
                <router-link tag="li" :to="{ name: 'visualization', query: {page: 1} }" exact>
                    <a class="nav-link"><font-awesome-icon icon="chart-pie" style="width: 25px" /> <span>Visualizations</span></a>
                </router-link>
                <router-link tag="li" :to="{ name: 'report', query: {page: 1} }" exact>
                    <a class="nav-link"><font-awesome-icon icon="file-alt" style="width: 25px" /> <span>Reports</span></a>
                </router-link>
            </ul>
        </section>
        <div class="brand pb-4">
            <ul class="sidebar-toggle">
                <li class="clearfix mb-2">
                    <a href="#" data-toggle="push-menu" id="push-menu" @click="toggleSidebar" role="button">
                        <span>Toggle navigation</span>
                    </a>
                </li>
            </ul>
            <div class="copyright">
                <strong>Copyright © 2020 <a href="https://www.dataproviders.io">Data Providers</a>.</strong>
                <br> All rights reserved.
            </div>
        </div>
    </aside>
</template>

<script>

    export default {
        data() {
            return {
                user_id: '',
                valid_email: 1,
                email_sended: 0,
                sidebarCollapsed: false,
            }
        },
        created() {
            this.$store.dispatch('fetchAccount')
                .then(() => {
                    this.user_id = this.$store.getters.getAccount.id;
                    this.valid_email = this.$store.getters.getAccount.valid_email;
                    this.$auth.user(this.$store.getters.getAccount);
                });
        },
        methods: {
            sendVerificationMail() {
                axios.get(`/users/email/resend/${this.user_id}/`)
                    .then(() => {
                        this.email_sended = 1
                    })
            },
            toggleSidebar() {
                if (localStorage.getItem('sidebarCollapsed') === null) {
                    localStorage.setItem('sidebarCollapsed', 'false');
                }
                else {
                    this.sidebarCollapsed = !this.sidebarCollapsed;
                    localStorage.setItem('sidebarCollapsed', this.sidebarCollapsed);
                }
            }
        },
        mounted() {
            if (localStorage.getItem('sidebarCollapsed') === null) {
                localStorage.setItem('sidebarCollapsed', 'false');
            }
            else {
                this.sidebarCollapsed = (localStorage.getItem('sidebarCollapsed') === 'true');
                if(this.sidebarCollapsed) {
                    $('[data-toggle="push-menu"]').pushMenu('toggle')
                }
            }
        }
    }    
</script>

<style scoped>
    .nav > li > a:active, .nav > li > a:focus {
	    color: #444;
	    background: #b2b2b2;
    }
    a {
	    color: #0a0a0b;
	    text-decoration: none;
    }
    .router-link-active > a {
        background-color: #f4f4f5;
    }
</style>
